import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {MarketingComponent} from './marketing/marketing.component';
import { AddCoinComponent } from './add-coin/add-coin.component';
import {LoggedGuard} from '../../../../_guard/logged.guard';
import { ViewCoinComponent } from './view-coin/view-coin.component';
import { TermsComponent } from './terms/terms.component';
import {PrivacyComponent} from './privacy/privacy.component';
import { AdvertisingComponent } from './advertising/advertising.component';
import {ContactPageComponent} from './contact-page/contact-page.component';

const routes: Routes = [
  {path: '', component: MarketingComponent, pathMatch: 'full'},
  {path: 'add-coin', component: AddCoinComponent,  canActivate: [LoggedGuard], pathMatch: 'full'},
  {path: 'coin/:slug', component: ViewCoinComponent, pathMatch: 'full'},
  {path: 'advertise', component: AdvertisingComponent,  pathMatch: 'full'},
  {path: 'terms-and-conditions', component: TermsComponent,  pathMatch: 'full'},
  {path: 'privacy-policy', component: PrivacyComponent, pathMatch: 'full'},
  {path: 'contact', component: ContactPageComponent, pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomepageRoutingModule { }
